import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import ReactGA from "react-ga4";
import ScrollReveal from "../../../utils/ScrollReveal";

// import sections
import NavLink from "../../../components/sections/partials/NavLink";
import ProjectTopDetail from "./ProjectTopDetail";
import ProjectBottomDetail from "./ProjectBottomDetail";

const trackPage = (page) => {
  ReactGA.send({ hitType: "pageview", page });
};

const ProjectDetail = ({
  childRef,
  projectName,
  projectLogoImg,
  tagNames,
  topImg,
  contentMessage,
  messageBlock1,
  messageBlock2,
  block1Img,
  block2Img,
  previousPageText,
  previousPageLink,
  ...props
}) => {
  let location = useLocation();
  const page = location.pathname;

  const goToTop = () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    document.body.classList.add("is-loaded");
    childRef.current.init();
    trackPage(page);
    goToTop();
  }, [childRef, location, page]);

  return (
    <ScrollReveal
      ref={childRef}
      children={() => (
        <React.Fragment>
          <div className="bg-top" />
          <NavLink
            id="NavLink"
            previousPageText={previousPageText}
            previousPageLink={previousPageLink}
            currentPageText={projectName}
          />
          <ProjectTopDetail
            id="ProjectTopDetail"
            projectName={projectName}
            projectLogoImg={projectLogoImg}
            tagNames={tagNames}
            projectMainImg={topImg}
            contentMessage={contentMessage}
          />
          <ProjectBottomDetail
            id="ProjectBottomDetail"
            projectName={projectName}
            messageBlock1={messageBlock1}
            messageBlock2={messageBlock2}
            block1Img={block1Img}
            block2Img={block2Img}
          />
          <div className="bg-bottom" />
        </React.Fragment>
      )}
    />
  );
};

export default ProjectDetail;
